import "./style.scss";

import type { TTags } from "components/Title";
import type { Dispatch, SetStateAction } from "react";
import type { IBrand } from "store/brandStore";

import type { FilterOrder } from "../ElementList/sortStorage";
import FilterInput from "../FilterInput";
import MultipleFilters from "./MultipleFilters";
import OrderFilter from "./OrderFilter";

interface ListFilters {
    searchValue: string;
    onSearchValue: (e: any) => void;
    orderOptions: { name: string; label: string }[];
    onOrderSelection: (value: FilterOrder) => void;
    chosenOrder: FilterOrder;
    tags: TTags[] | null | undefined;
    chosenTags: string[];
    setChosenTags: Dispatch<SetStateAction<string[]>>;
    usesBrands: boolean | undefined;
    chosenBrand: string;
    setChosenBrand: Dispatch<SetStateAction<string>>;
    brands: IBrand[] | undefined;
    companyName: string | undefined;
    showHasTermFilter?: boolean;
    withoutTermOnly?: boolean;
    setWithoutTermOnly?: (value: boolean) => void;
    showTagFilter?: boolean;
}

const ListFilters = ({
    searchValue,
    onSearchValue,
    orderOptions,
    onOrderSelection,
    chosenOrder,
    tags,
    chosenTags,
    setChosenTags,
    usesBrands,
    chosenBrand,
    setChosenBrand,
    brands,
    companyName,
    showHasTermFilter,
    withoutTermOnly,
    setWithoutTermOnly,
    showTagFilter = true,
}: ListFilters) => {
    const showExtraFilters = showTagFilter || Boolean(usesBrands) || Boolean(showHasTermFilter);

    return (
        <div className="element-list-filters">
            <FilterInput filterValue={searchValue} setFilterValue={onSearchValue} />
            <OrderFilter orderOptions={orderOptions} onSelection={onOrderSelection} chosenOrder={chosenOrder} />
            {showExtraFilters && (
                <MultipleFilters
                    tags={tags ?? null}
                    chosenTags={chosenTags}
                    setChosenTags={setChosenTags}
                    usesBrands={usesBrands}
                    chosenBrand={chosenBrand}
                    setChosenBrand={setChosenBrand}
                    brands={brands}
                    companyName={companyName}
                    showHasTermFilter={showHasTermFilter}
                    withoutTermOnly={withoutTermOnly}
                    setWithoutTermOnly={setWithoutTermOnly}
                />
            )}
        </div>
    );
};

export default ListFilters;
